import _get from 'lodash/get';
import { FetchError } from '@bedrock/fido-sdk';
import { ERROR_LEVELS } from './error.constants';

export const getErrorLevel = error => {
  /**
   * if something went wrong (network issue on client side for example) while requesting data, fido returns an error
   * error object will include request and name field, so we can define type of error using this data
   * in cases where fetching some data is critical, this error must be FATAL
   */
  if (error.fatal || (error.request && error.name === FetchError.name)) {
    return ERROR_LEVELS.FATAL;
  }

  return ERROR_LEVELS.SILENT;
};

export const fetchErrorMessage = error => {
  const errorCode = _get(error, 'content.code', error.code);

  return error.message || errorCode || error.detail;
};
